import {
  Home,
  Info,
  Star,
  FileText,
  Settings,
  Phone,
  CreditCard,
  BookOpen,
  Newspaper,
  MessageSquareQuote,
  Users,
  HelpCircle,
  LayoutGrid,
  Gift,
} from "lucide-react";

const constants = {
  API: {
    BASE_URL: "https://backend.gyaankool.com",
  },
  S3_BUCKET: {
    BASE_URL: "https://f895b6394e278c5725bee7ac10fa1a9f.r2.cloudflarestorage.com/",
  },
  USER_ROLES: {
    STUDENT: "student",
    COACH: "coach",
    ADMIN: "admin",
    SUPER_ADMIN: "super-admin",
  },
  COLOR: {
    PRIMARY: "#393188",
  },
  MESSAGES: {
    REQUIRED_FIELD: "This field is required",
    SUCCESS: "Success",
    DATA_IS_UPDATED_SUCCESSFULLY: "Data is updated successfully.",
    DATA_IS_ADDED_SUCCESSFULLY: "Data is added successfully.",
    FAILED: "Failed",
    INVALID_CREDS: "Username/Password is invalid.",
    INTERNAL_SERVER_ERROR: "Internal server error.",
  },
  DATE_TIME_FORMATS: {
    DATE_FLATPICKER: "d-m-Y",
    DATE_FLATPICKER_CERT: "d/m/Y",
    DATE_UI: "DD-MM-YYYY",
    DATE_API: "YYYY-MM-DD",
    DATE_FULL_MONTH: "DD-MMM-YYYY",
    DATE_DAY: "day",
    DATE_DAYS: "days",
    FULL_MONTH: "MMM YYYY",
    TIME_12_HR: "h:mma",
    TIME_24_HR: "HH:mm",
    FULL_TIME: "HH:mm:ss",
  },
  BACK_BUTTON_SCREENS: ["/add-plan?", "/add-blog", "/testimonials/add", "/faq/add"],
  MENU_ITEMS: {
    PAGES: [
      { id: 1, label: "Home", link: "/home", icon: Home },
      { id: 2, label: "About Us", link: "/aboutus", icon: Info },
      { id: 3, label: "Features", link: "/features", icon: Star },
      { id: 4, label: "Features Demo", link: "/features-demo", icon: FileText },
      { id: 5, label: "How It Works", link: "/how-it-works", icon: Settings },
      { id: 6, label: "Contact Us", link: "/contact-us", icon: Phone },
      { id: 7, label: "Plans Content", link: "/plans", icon: CreditCard },
      { id: 8, label: "Courses", link: "/courses", icon: BookOpen },
    ],
    MASTER_PAGES: [
      { id: 1, label: "Blogs", link: "/blogs", icon: Newspaper },
      { id: 2, label: "Coach Courses", link: "/coach-courses", icon: BookOpen },
      { id: 3, label: "Testimonials", link: "/testimonials", icon: MessageSquareQuote },
      { id: 4, label: "Plans", link: "/plans-list", icon: Newspaper },
      { id: 11, label: "Free Trial", link: "/free-trial", icon: Gift },
      { id: 5, label: "Leads", link: "/leads", icon: Users },
      { id: 6, label: "Demo Requests", link: "/demo-requests", icon: Users },
      { id: 7, label: "Subscribe Leads", link: "/subscribe-leads", icon: Users },
      { id: 8, label: "FAQs", link: "/faq", icon: HelpCircle },
      { id: 9, label: "Query Form Schema", link: "/query-form", icon: LayoutGrid },
      { id: 10, label: "Query Form Responses", link: "/query-form-responses", icon: Users },
    ],
    MISC: [
      // Sales and user provisioning live in the coach app's super-admin login (app.gyaankool.com),
      // not here: this panel is site content, the super-admin is platform operations.
      { id: 3, label: "Footer", link: "/footer", icon: LayoutGrid },
    ],
  },

  USERS: {
    ADMIN: { id: "ADMIN", pass: "ADMIN", role: "ADMIN" },
  },

  getS3File: (url) => {
    if (!url) return "";
    if (typeof url === "string" && (url.startsWith("http://") || url.startsWith("https://"))) {
      return url;
    }
    const baseUrl = constants?.S3_BUCKET?.BASE_URL ||
      process.env.REACT_APP_R2_BASE_URL ||
      process.env.REACT_APP_S3_BASE_URL ||
      "https://pub-823d0473e6d140e69888809062cdad59.r2.dev";
    const cleanBase = baseUrl.endsWith("/") ? baseUrl : `${baseUrl}/`;
    const cleanUrl = String(url).replace(/^\/+/, "");
    return `${cleanBase}${cleanUrl}`;
  },

  STORAGE_KEYS: {
    USER: "user",
  },
};

export default constants;
